export class UpdateOrderDTO {
  constructor(order) {
    this.id = order.id
    this.status = order.status
  }
}